<template>
    <div id="paperaddr">
        <!-- {{PlugJson}} -->
    </div>
</template>

<script>
export default {
    name:'paperaddr'
}
</script>

<style scoped>

</style>